<template>
  <div id="mainBox">
    <div class="historyTag">
      <historyTag :historyArr="historyArr"></historyTag>
    </div>

    <div class="flex search-box">
      <div class="search-item">
        <span style="white-space: nowrap; margin-right: 8px">状态：</span>
        <div style="width: 140px">
          <el-select v-model="query.status" placeholder="全部" clearable @change="searchFn">
            <el-option v-for="item in dicts.statusOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </div>
      </div>

      <div class="search-item">
        <span style="white-space: nowrap; margin-right: 8px">订单类型：</span>
        <div style="width: 140px">
          <el-select v-model="query.orderType" placeholder="全部" clearable @change="searchFn">
            <el-option v-for="item in dicts.orderTypeOptions" :key="item.value" :label="item.label"
              :value="item.value" />
          </el-select>
        </div>
      </div>

      <div class="search-item">
        <span style="white-space: nowrap; margin-right: 8px">鉴别类型：</span>
        <div style="width: 168px">
          <el-select v-model="query.inspectionType" placeholder="全部" clearable @change="searchFn">
            <el-option v-for="item in dicts.inspectionTypeOptions" :key="item.value" :label="item.label"
              :value="item.value" />
          </el-select>
        </div>
      </div>

      <div class="search-item">
        <span style="white-space: nowrap; margin-right: 8px">鉴别号：</span>
        <div style="width: 180px">
          <el-input v-model="query.inspectionNo" placeholder="精准查询" clearable @keyup.enter.native="searchFn" />
        </div>
      </div>

      <div class="search-item">
        <span style="white-space: nowrap; margin-right: 8px">订单号：</span>
        <div style="width: 180px">
          <el-input v-model="query.orderNo" placeholder="模糊查询" clearable @keyup.enter.native="searchFn" />
        </div>
      </div>

      <div class="search-item">
        <span style="white-space: nowrap; margin-right: 8px">货架号：</span>
        <div style="width: 120px">
          <el-input v-model="query.shelfNo" placeholder="精准查询" clearable @keyup.enter.native="searchFn" />
        </div>
      </div>

      <div class="search-item">
        <span style="white-space: nowrap; margin-right: 8px">时间：</span>
        <div style="width: 290px">
          <el-date-picker v-model="query.timeRange" type="daterange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期" value-format="yyyy-MM-dd" />
        </div>
      </div>
    </div>


    <div class="operate-btns">
      <el-button type="success" size="medium" @click="searchFn">搜索</el-button>
      <el-button size="medium" @click="resetFn">重置</el-button>
      <el-button type="warning" size="medium" @click="openBatchUploadDialog">批量上传谱图数据</el-button>
      <el-button type="primary" size="medium" @click="copyTodayLiquidInspectionSeq">复制液体鉴别序号</el-button>
    </div>


    <div class="table-scroll-wrap">
    <el-table class="data-table" :data="tableData" border style="width: 100%; margin-top: 12px" v-loading="loading"
      @selection-change="handleSelectionChange">
      <el-table-column prop="inspectionNo" label="鉴别号" min-width="150" align="center">
        <template slot-scope="scope">
          <span class="inspection-no">{{ scope.row.inspectionNo }}</span>
          <el-tag v-if="scope.row.inspectionNoPrintFlag === 1" type="success" size="mini"
            style="margin-left: 4px">已打印</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="orderType" label="订单类型" width="100" align="center">
        <template slot-scope="scope">{{ getDictLabel('orderTypeOptions', scope.row.orderType) }}</template>
      </el-table-column>
      <el-table-column prop="inspectionType" label="鉴别类型" width="128" align="center">
        <template slot-scope="scope">{{ platformInspectionTypeLabel(scope.row.inspectionType) }}</template>
      </el-table-column>
      <el-table-column prop="orderNo" label="订单号" min-width="160" align="center" />
      <el-table-column label="商品信息" min-width="220" class-name="cell-title-wrap">
        <template slot-scope="scope">
          <div style="line-height: 1.6">
            <div v-if="scope.row.productTitle">{{ scope.row.productTitle }}</div>
            <div v-if="brandDisplay(scope.row)">品牌：{{ brandDisplay(scope.row) }}</div>
            <div v-if="typeDisplay(scope.row)">型号：{{ typeDisplay(scope.row) }}</div>
            <div v-if="scope.row.batchNum">批次号：{{ scope.row.batchNum }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="图片" width="108" align="center">
        <template slot-scope="scope">
          <div class="job-img-cell" v-if="productImageUrls(scope.row).length">
            <el-image
              v-for="(url, idx) in productImageUrls(scope.row).slice(0, 2)"
              :key="idx"
              class="job-img-thumb"
              :src="url"
              fit="cover"
              :preview-src-list="productImageUrls(scope.row)"
            />
          </div>
          <span v-else style="color: #999">-</span>
        </template>
      </el-table-column>
      <el-table-column label="备注" min-width="100" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ scope.row.orderDepict || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="管理员备注" min-width="100" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ scope.row.adminBz || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="100" align="center">
        <template slot-scope="scope">
          <span :style="{ color: getDictColor('statusOptions', scope.row.status) }">{{ getDictLabel('statusOptions',
            scope.row.status) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="外观鉴别" width="90" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.resultAppearance" :style="{ color: getDictColor('resultOptions', scope.row.resultAppearance), fontWeight: 'bold' }">
            {{ getDictLabel('resultOptions', scope.row.resultAppearance) }}
          </span>
          <span v-else style="color: #909399;">-</span>
        </template>
      </el-table-column>
      <el-table-column prop="ychl" label="乙醇含量" width="90" align="center" />
      <el-table-column prop="shelfNo" label="货架号" width="100" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.shelfNo">{{ scope.row.shelfNo }}</span>
          <span v-else style="color: #999">未绑定</span>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="160" align="center">
        <template slot-scope="scope">{{ formatTime(scope.row.createTime) }}</template>
      </el-table-column>
      <el-table-column label="鉴别结果" width="80" align="center" fixed="right">
        <template slot-scope="scope">
          <span v-if="scope.row.result" :style="{ color: getDictColor('resultOptions', scope.row.result) }">
            {{ getDictLabel('resultOptions', scope.row.result) }}
          </span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="148" width="148" align="left" fixed="right" class-name="job-op-col">
        <template slot-scope="scope">
          <div class="job-op-btns">
            <el-button size="mini" @click="showDetailDialog(scope.row)">详情</el-button>
            <el-button size="mini" type="warning" @click="openOrderVerify(scope.row)" v-if="[1, 2].includes(scope.row.status) && scope.row.orderType != 4">鉴别</el-button>
            <el-button size="mini" type="warning" @click="openSecondHandVerify(scope.row)" v-if="[1, 2].includes(scope.row.status) && scope.row.orderType == 4">{{ isSecondHandReissue(scope.row) ? '重新出具' : '鉴别' }}</el-button>
            <el-button size="mini" type="warning" plain @click="openOrderVerifyEdit(scope.row)" v-if="canEditInspectionResult(scope.row) && scope.row.orderType != 4">修改鉴别</el-button>
            <el-button size="mini" type="warning" plain @click="openSecondHandVerifyEdit(scope.row)" v-if="canEditInspectionResult(scope.row) && scope.row.orderType == 4">修改鉴别</el-button>
            <el-button size="mini" type="primary" @click="printInspectionReport(scope.row)" v-if="canPrintInspectionJobReport(scope.row)">鉴别报告打印</el-button>
            <el-button size="mini" type="primary" plain @click="openReportPreview(scope.row)" v-if="canPreviewInspectionJobReport(scope.row)">查看报告</el-button>
            <el-button size="mini" type="success" @click="goConsignmentGrade(scope.row)" v-if="canConsignmentGrade(scope.row)">评级</el-button>
            <el-button size="mini" type="info" @click="rollbackStatus(scope.row)" v-if="canRollbackJob(scope.row)">回滚</el-button>
            <el-button
              v-if="canXwOrderRefund(scope.row)"
              size="mini"
              type="danger"
              plain
              @click="refundXwOrder(scope.row)"
            >退款</el-button>
            <el-button
              v-if="canCloseXwOrderJob(scope.row)"
              size="mini"
              type="info"
              plain
              @click="closeXwOrder(scope.row)"
            >取消订单</el-button>
            <el-button
              v-if="canInspectionIssueRefund(scope.row)"
              size="mini"
              type="danger"
              plain
              :loading="issueRefundLoadingId === scope.row.orderId"
              @click="refundInspectionIssue(scope.row)"
            >不符退回退款</el-button>
            <el-button
              v-if="canSecondhandReverseRefund(scope.row)"
              size="mini"
              type="danger"
              plain
              @click="openReverseRefundDialog(scope.row)"
            >未分账退款</el-button>
            <el-button
              v-if="canSecondhandDivRefund(scope.row)"
              size="mini"
              type="warning"
              plain
              @click="openDivRefundDialog(scope.row)"
            >已分账退款</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    </div>

    <list-pagination
      :total="tableTotal"
      :current-page.sync="currentPage"
      :page-size.sync="pageSize"
      @page-change="changePage"
      @size-change="handlePageSizeChange"
    />

    <!-- 详情弹窗 - 使用动态组件加载detail.vue -->
    <el-dialog :title="detailDialogTitle" :visible.sync="detailDialogVisible" width="880px" :close-on-click-modal="false"
      custom-class="inspection-job-detail-dialog" @closed="onDetailDialogClosed">
      <div class="detail-dialog-body">
        <InspectionJobDetail
          v-if="detailJobId"
          :key="detailJobId"
          :job-id="detailJobId"
          :preview-row="detailPreviewRow"
          @loaded="onDetailLoaded"
        />
      </div>
    </el-dialog>

    <el-dialog :title="secondHandVerifyDialogTitle" :visible.sync="secondHandVerifyVisible" width="1000px" :close-on-click-modal="false"
      custom-class="inspection-verify-dialog" @closed="onSecondHandVerifyClosed">
      <SecondHandVerify
        v-if="secondHandVerifyOrderId"
        :order-id="secondHandVerifyOrderId"
        :inspection-job-id="secondHandVerifyJobId"
        :initial-inspection-type="secondHandVerifyInspectionType"
        :initial-inspection-no="secondHandVerifyInspectionNo"
        :initial-job-status="secondHandVerifyJobStatus"
        :edit-mode="secondHandVerifyEditMode"
        @close="secondHandVerifyVisible = false"
        @success="onSecondHandVerifySuccess"
      />
    </el-dialog>

    <el-dialog :title="orderVerifyEditMode ? '修改鉴别结果' : '鉴别结果'" :visible.sync="orderVerifyVisible" width="1000px" :close-on-click-modal="false"
      custom-class="inspection-verify-dialog" @closed="onOrderVerifyClosed">
      <OrderVerify v-if="orderVerifyJobId" :job-id="orderVerifyJobId"
        :initial-result-appearance="orderVerifyInitialAppearance"
        :edit-mode="orderVerifyEditMode"
        @close="orderVerifyVisible = false" @success="onOrderVerifySuccess" />
    </el-dialog>

    <!-- 批量上传谱图弹窗 -->
    <div class="excellent_box" v-if="batchUploadDialogVisible">
      <div class="excellent_main">
        <div class="excellent_top">
          批量上传谱图
          <i class="el-icon-close" @click.stop="closeBatchUploadDialog"></i>
        </div>
        <div class="excellent_content">
          <div class="excellent_li">
            <div class="txt-upload-container">
              <div class="txt-upload-left">
                <el-button size="small" type="primary" @click="triggerTxtFileSelect">选择 TXT 文件</el-button>
                <input ref="txtFileInput" type="file" accept=".txt,text/plain" style="display: none"
                  @change="onTxtFileSelected" multiple />
              </div>
              <div class="txt-upload-right">
                <el-button type="success" size="small" :loading="batchUploadLoading" :disabled="!canBatchUpload"
                  @click="submitBatchUpload">确定上传</el-button>
              </div>
            </div>
          </div>
          <div slot="tip" class="el-upload__tip">
            支持 txt 格式文件，最多上传100个<br />
            文件名格式：鉴别号+酒精浓度.txt（如：260728-1-16+73.3.txt）<br />
          </div>
          <div v-if="selectedTxtFiles && selectedTxtFiles.length > 0" class="selected-files">
            <div class="files-header">已选择 {{ selectedTxtFiles.length }} 个文件：</div>
            <div v-for="(file, index) in selectedTxtFiles" :key="index" class="file-item">
              {{ file.name }}
            </div>
          </div>
          <div v-else class="no-files">暂未选择文件</div>
        </div>
      </div>
    </div>

    <el-dialog
      title="鉴别报告预览"
      :visible.sync="reportPreviewVisible"
      width="420px"
      top="4vh"
      custom-class="inspection-report-preview-dialog"
      :close-on-click-modal="false"
      @closed="onReportPreviewClosed"
    >
      <div class="report-preview-dialog-body">
        <JbReportPreview
          v-if="reportPreviewOrderId"
          :key="reportPreviewOrderId + '-' + reportPreviewOrderType"
          :order-id="reportPreviewOrderId"
          :order-type="reportPreviewOrderType"
        />
      </div>
    </el-dialog>

    <el-dialog
      title="打印状态"
      :visible.sync="printDialogVisible"
      width="400px"
      :before-close="handleClosePrintDialog"
    >
      <div style="text-align: center; padding: 20px;">
        {{ printResultMessage }}
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClosePrintDialog">关 闭</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="汇付未分账退款（支付撤销）"
      :visible.sync="reverseRefundVisible"
      width="520px"
      :close-on-click-modal="false"
    >
      <el-form :model="reverseRefundForm" label-width="110px">
        <el-form-item label="订单号">
          <el-input :value="(reverseRefundOrder && reverseRefundOrder.orderNo) || '-'" disabled />
        </el-form-item>
        <el-form-item label="支付金额(元)">
          <el-input :value="formatMoney(reverseRefundOrder && reverseRefundOrder.sourceOrderTotalAmount)" disabled />
        </el-form-item>
        <el-form-item label="退款金额(元)">
          <el-input v-model.trim="reverseRefundForm.refundAmount" placeholder="不填默认全额退款" />
        </el-form-item>
        <el-form-item label="退款原因">
          <el-input
            v-model.trim="reverseRefundForm.reason"
            type="textarea"
            :rows="3"
            maxlength="100"
            show-word-limit
            placeholder="选填"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="reverseRefundVisible = false">取消</el-button>
        <el-button type="primary" :loading="reverseRefundSubmitLoading" @click="submitReverseRefund">确认退款</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="汇付已分账退款（创建退款对象）"
      :visible.sync="divRefundVisible"
      width="520px"
      :close-on-click-modal="false"
    >
      <el-form :model="divRefundForm" label-width="110px">
        <el-form-item label="订单号">
          <el-input :value="(divRefundOrder && divRefundOrder.orderNo) || '-'" disabled />
        </el-form-item>
        <el-form-item label="支付金额(元)">
          <el-input :value="formatMoney(divRefundOrder && divRefundOrder.sourceOrderTotalAmount)" disabled />
        </el-form-item>
        <el-form-item label="退款金额(元)">
          <el-input v-model.trim="divRefundForm.refundAmount" placeholder="不填默认全额退款" />
        </el-form-item>
        <el-form-item label="退款原因">
          <el-input
            v-model.trim="divRefundForm.reason"
            type="textarea"
            :rows="3"
            maxlength="100"
            show-word-limit
            placeholder="选填"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="divRefundVisible = false">取消</el-button>
        <el-button type="primary" :loading="divRefundSubmitLoading" @click="submitDivRefund">确认退款</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import historyTag from "@/components/historyTag";
import InspectionJobDetail from "./detail.vue";
import SecondHandVerify from "./secondHandVerify.vue";
import OrderVerify from "./orderVerify.vue";
import JbReportPreview from "@/components/jbReport/JbReportPreview.vue";
import { api } from "@/util/requestUrl";
import { runXwOrderRefund, runXwOrderClose, canCloseXwOrder, canRefundXwOrder, resolveXwOrderAmounts } from "@/util/xwOrderRefund";
import {
  buildDefaultTimeRange,
  resolveCreateTimeRange,
} from "@/util/inspectionJobTimeRange";
import {
  PLATFORM_INSPECTION_TYPE_FILTER_OPTIONS,
  buildInspectionTypeListParams,
  platformInspectionTypeLabel,
} from "@/util/platformInspectionType";
import { brandDisplay, productImageUrls, typeDisplay } from "@/util/inspectionJobDisplay";
import reportLabelPrintMixin from "@/mixins/reportLabelPrintMixin";
import {
  buildInspectionJobReportQrUrl,
  canEditInspectionResult,
  canPrintInspectionJobReport,
  canPreviewInspectionJobReport,
  inspectionJobReportLabelSuffix,
} from "@/util/inspectionReportQr";
import {
  savePageState,
  consumePageState,
  clearPageState,
  PAGE_STATE_KEYS,
} from "@/util/listPageState";

export default {
  mixins: [reportLabelPrintMixin],
  components: {
    historyTag,
    InspectionJobDetail,
    SecondHandVerify,
    OrderVerify,
    JbReportPreview,
  },
  data() {
    return {
      historyArr: ["鉴别作业", "作业列表"],
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 50,
      tableTotal: 0,

      query: {
        status: null,
        orderType: null,
        inspectionType: null,
        inspectionNo: "",
        orderNo: "",
        shelfNo: "",
        timeRange: buildDefaultTimeRange(),
      },

      dicts: {
        statusOptions: [
          { value: 1, label: "平台鉴别中", color: "#E6A23C", tag: "warning" },
          { value: 2, label: "待鉴别结果出具", color: "#409EFF", tag: "primary" },
          { value: 3, label: "待平台寄售评级", color: "#409EFF", tag: "info" },
          { value: 4, label: "待发货", color: "#67C23A", tag: "success" },
          { value: 5, label: "已完成", color: "#909399", tag: "info" },
        ],

        orderTypeOptions: [
          { value: 1, label: "寄售订单" },
          { value: 2, label: "鉴别订单" },
          { value: 3, label: "闲置订单" },
          { value: 4, label: "安心购订单" },
        ],

        inspectionTypeOptions: PLATFORM_INSPECTION_TYPE_FILTER_OPTIONS,

        resultOptions: [
          { value: 1, label: "通过", color: "#67C23A" },
          { value: 2, label: "不通过", color: "#F56C6C" },
        ],
      },

      detailDialogVisible: false,
      detailJobId: null,
      detailPreviewRow: null,
      detailDialogTitle: "鉴别作业详情",

      secondHandVerifyVisible: false,
      secondHandVerifyOrderId: null,
      secondHandVerifyJobId: null,
      secondHandVerifyInspectionType: null,
      secondHandVerifyInspectionNo: null,
      secondHandVerifyJobStatus: null,
      secondHandVerifyEditMode: false,
      secondHandVerifyReissue: false,

      orderVerifyVisible: false,
      orderVerifyJobId: null,
      orderVerifyInitialAppearance: null,
      orderVerifyEditMode: false,

      batchUploadDialogVisible: false,
      selectedJobs: [],
      selectedTxtFiles: [],
      batchUploadLoading: false,

      issueRefundLoadingId: null,
      reverseRefundVisible: false,
      reverseRefundOrder: null,
      reverseRefundForm: { refundAmount: "", reason: "" },
      reverseRefundSubmitLoading: false,
      divRefundVisible: false,
      divRefundOrder: null,
      divRefundForm: { refundAmount: "", reason: "" },
      divRefundSubmitLoading: false,

      reportPreviewVisible: false,
      reportPreviewOrderId: null,
      reportPreviewOrderType: null,
    };
  },
  computed: {
    canBatchUpload: function () {
      return this.selectedTxtFiles && this.selectedTxtFiles.length > 0;
    },
    secondHandVerifyDialogTitle() {
      if (this.secondHandVerifyEditMode) return "修改鉴别";
      if (this.secondHandVerifyReissue) return "安心购重新出具";
      return "安心购鉴别";
    },
  },
  mounted() {
    this.restoreListState();
    this.getList();
  },
  methods: {
    saveListState() {
      savePageState(PAGE_STATE_KEYS.INSPECTION_JOB_LIST, {
        query: { ...this.query },
        currentPage: this.currentPage,
        pageSize: this.pageSize,
      });
    },
    restoreListState() {
      const saved = consumePageState(PAGE_STATE_KEYS.INSPECTION_JOB_LIST);
      if (!saved) return;
      if (saved.query) {
        this.query = Object.assign({}, this.query, saved.query);
      }
      if (saved.currentPage) this.currentPage = saved.currentPage;
      if (saved.pageSize) this.pageSize = saved.pageSize;
    },
    platformInspectionTypeLabel,
    canPrintInspectionJobReport,
    canPreviewInspectionJobReport,
    canEditInspectionResult,

    printInspectionReport(row) {
      if (!canPrintInspectionJobReport(row)) {
        this.$message.warning("仅已出具鉴别结论的作业可打印报告");
        return;
      }
      const qrUrl = buildInspectionJobReportQrUrl(row);
      if (!qrUrl) {
        this.$message.warning("缺少订单信息，无法生成二维码");
        return;
      }
      this.startReportLabelPrint(row, () => ({
        var7: inspectionJobReportLabelSuffix(row),
        var8: qrUrl,
      }));
    },

    openReportPreview(row) {
      if (!canPreviewInspectionJobReport(row)) {
        this.$message.warning("当前作业暂无可预览的报告");
        return;
      }
      this.reportPreviewOrderId = row.orderId;
      this.reportPreviewOrderType = row.orderType;
      this.reportPreviewVisible = true;
    },

    onReportPreviewClosed() {
      this.reportPreviewOrderId = null;
      this.reportPreviewOrderType = null;
    },

    getList() {
      this.loading = true;

      var params = {
        page: this.currentPage,
        size: this.pageSize,
        status: this.query.status || null,
        orderType: this.query.orderType || null,
        inspectionNo: this.query.inspectionNo || null,
        orderNo: this.query.orderNo || null,
        shelfNo: this.query.shelfNo || null,
      };

      Object.assign(params, buildInspectionTypeListParams(this.query.inspectionType));
      Object.assign(params, resolveCreateTimeRange(this.query.timeRange));

      this.$axios
        .post(api.getInspectionJobList, params)
        .then((res) => {
          this.loading = false;
          if (res.data.code === 200) {
            this.tableData = res.data.data.records || [];
            this.tableTotal = res.data.data.total || 0;
          } else {
            this.$message.error(res.data.msg || "获取列表失败");
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("网络异常");
        });
    },

    searchFn() {
      this.currentPage = 1;
      this.getList();
    },

    resetFn() {
      clearPageState(PAGE_STATE_KEYS.INSPECTION_JOB_LIST);
      this.query = {
        status: null,
        orderType: null,
        inspectionType: null,
        inspectionNo: "",
        orderNo: "",
        shelfNo: "",
        timeRange: null,
      };
      this.currentPage = 1;
      this.getList();
    },

    changePage(page) {
      this.currentPage = page;
      this.getList();
    },

    handlePageSizeChange() {
      this.getList();
    },

    handleSelectionChange(selection) {
      this.selectedJobs = selection;
    },

    showDetailDialog(row) {
      this.detailPreviewRow = row ? { ...row } : null;
      this.detailJobId = row.id;
      this.detailDialogTitle = row && row.inspectionNo
        ? "鉴别详情 · " + row.inspectionNo
        : "鉴别作业详情";
      this.detailDialogVisible = true;
    },

    onDetailLoaded(data) {
      if (data && data.inspectionNo) {
        this.detailDialogTitle = "鉴别详情 · " + data.inspectionNo;
      }
    },

    onDetailDialogClosed() {
      this.detailJobId = null;
      this.detailPreviewRow = null;
      this.detailDialogTitle = "鉴别作业详情";
    },

    openSecondHandVerify(row) {
      this.secondHandVerifyOrderId = row.orderId;
      this.secondHandVerifyJobId = row.id != null ? row.id : null;
      this.secondHandVerifyInspectionType = row.inspectionType != null ? row.inspectionType : null;
      this.secondHandVerifyInspectionNo = row.inspectionNo || null;
      this.secondHandVerifyJobStatus = row.status != null ? Number(row.status) : null;
      this.secondHandVerifyEditMode = false;
      this.secondHandVerifyReissue = this.isSecondHandReissue(row);
      this.secondHandVerifyVisible = true;
    },

    openSecondHandVerifyEdit(row) {
      if (!canEditInspectionResult(row)) {
        this.$message.warning("当前作业不可修改鉴别结果");
        return;
      }
      this.secondHandVerifyOrderId = row.orderId;
      this.secondHandVerifyJobId = row.id != null ? row.id : null;
      this.secondHandVerifyInspectionType = row.inspectionType != null ? row.inspectionType : null;
      this.secondHandVerifyInspectionNo = row.inspectionNo || null;
      this.secondHandVerifyJobStatus = row.status != null ? Number(row.status) : null;
      this.secondHandVerifyEditMode = true;
      this.secondHandVerifyReissue = false;
      this.secondHandVerifyVisible = true;
    },

    /** 作业已回滚到待鉴别/待出具，但订单侧已出过报告 → 可重新出具 */
    isSecondHandReissue(row) {
      if (!row || Number(row.orderType) !== 4) return false;
      if (![1, 2].includes(Number(row.status))) return false;
      const flow = row.sourceInspectionFlowStatus != null
        ? Number(row.sourceInspectionFlowStatus)
        : null;
      if (flow != null && flow >= 4) return true;
      const result = Number(row.result);
      return result === 1 || result === 2;
    },

    onSecondHandVerifyClosed() {
      this.secondHandVerifyOrderId = null;
      this.secondHandVerifyJobId = null;
      this.secondHandVerifyInspectionType = null;
      this.secondHandVerifyInspectionNo = null;
      this.secondHandVerifyJobStatus = null;
      this.secondHandVerifyEditMode = false;
      this.secondHandVerifyReissue = false;
    },

    onSecondHandVerifySuccess() {
      this.secondHandVerifyVisible = false;
      this.secondHandVerifyOrderId = null;
      this.secondHandVerifyJobId = null;
      this.secondHandVerifyInspectionType = null;
      this.secondHandVerifyInspectionNo = null;
      this.secondHandVerifyJobStatus = null;
      this.secondHandVerifyEditMode = false;
      this.secondHandVerifyReissue = false;
      this.getList();
    },

    /** 寄售订单且鉴别通过（真）时展示寄售评级入口 */
    canConsignmentGrade(row) {
      if (!row || !row.orderId) return false;
      if (Number(row.orderType) !== 1) return false;
      if (Number(row.result) !== 1) return false;
      const status = Number(row.status);
      return status >= 3 && status <= 5;
    },

    goConsignmentGrade(row) {
      if (!this.canConsignmentGrade(row)) {
        this.$message.warning("仅寄售订单、鉴别为真且平台鉴别完成后可进行评级");
        return;
      }
      this.saveListState();
      this.$router.push({
        path: "/goodsOrder/consignmentGrade",
        query: { orderId: row.orderId, from: "inspectionJob" },
      });
    },

    openOrderVerify(row) {
      this.orderVerifyJobId = row.id;
      this.orderVerifyEditMode = false;
      this.orderVerifyInitialAppearance = row.resultAppearance != null ? Number(row.resultAppearance) : null;
      this.orderVerifyVisible = true;
    },

    openOrderVerifyEdit(row) {
      if (!canEditInspectionResult(row)) {
        this.$message.warning("当前作业不可修改鉴别结果");
        return;
      }
      this.orderVerifyJobId = row.id;
      this.orderVerifyEditMode = true;
      this.orderVerifyInitialAppearance = row.resultAppearance != null ? Number(row.resultAppearance) : null;
      this.orderVerifyVisible = true;
    },

    onOrderVerifyClosed() {
      this.orderVerifyJobId = null;
      this.orderVerifyInitialAppearance = null;
      this.orderVerifyEditMode = false;
    },

    onOrderVerifySuccess() {
      this.orderVerifyVisible = false;
      this.orderVerifyJobId = null;
      this.orderVerifyEditMode = false;
      this.getList();
    },

    canRollbackJob(row) {
      if (!row) return false;
      const status = Number(row.status);
      if (status === 5) return false;
      if (status > 1) return true;
      if (status !== 1) return false;
      const orderType = Number(row.orderType);
      if (orderType === 1 || orderType === 2) {
        return Number(row.sourceOrderStatus) === 2;
      }
      if (orderType === 4) {
        return Number(row.sourceInspectionFlowStatus) === 3;
      }
      return false;
    },

    rollbackStatus(row) {
      if (!this.canRollbackJob(row)) {
        this.$message.warning("当前状态无法回滚");
        return;
      }
      const tip = Number(row.status) === 1
        ? "回滚后将撤销鉴别作业并回退关联订单状态，确定继续？"
        : "确定要回滚状态吗？";
      this.$confirm(tip, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$axios
          .post(api.rollbackInspectionJobStatus, {
            id: row.id,
          })
          .then((res) => {
            if (res.data.code === 200) {
              this.$message.success((res.data && res.data.msg) || "回滚成功");
              this.getList();
            } else {
              this.$message.error(res.data.msg || "回滚失败");
            }
          })
          .catch(() => {
            this.$message.error("网络异常");
          });
      }).catch(() => {});
    },

    openBatchUploadDialog() {
      this.batchUploadDialogVisible = true;
      this.selectedTxtFiles = [];
    },

    copyTodayLiquidInspectionSeq() {
      // 构造请求参数：若有时间范围则传递，否则后端默认查当日
      const params = {};
      Object.assign(params, resolveCreateTimeRange(this.query.timeRange));
      this.$https(api.getWaitLiquidInspectionSeq, params, "POST").then((res) => {
        if (res.data && res.data.code === 200) {
          const seq = res.data.data || "";
          if (!seq) {
            this.$message.warning("暂无液体鉴别序号");
            return;
          }
          // 复制到剪切板
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(seq).then(() => {
              this.$message.success("复制成功");
            }).catch(() => {
              this.$message.error("复制失败");
            });
          } else {
            // 降级处理
            const textarea = document.createElement("textarea");
            textarea.value = seq;
            textarea.style.position = "fixed";
            textarea.style.opacity = "0";
            document.body.appendChild(textarea);
            textarea.select();
            try {
              document.execCommand("copy");
              this.$message.success("复制成功");
            } catch (e) {
              this.$message.error("复制失败");
            }
            document.body.removeChild(textarea);
          }
        } else {
          this.$message.error(res.data.msg || "获取数据失败");
        }
      }).catch(() => {
        this.$message.error("获取数据失败");
      });
    },

    triggerTxtFileSelect() {
      this.$refs.txtFileInput.click();
    },

    onTxtFileSelected(e) {
      var files = e.target.files;
      if (files && files.length > 0) {
        this.selectedTxtFiles = Array.from(files);
      }
    },

    closeBatchUploadDialog() {
      this.batchUploadDialogVisible = false;
      this.selectedTxtFiles = [];
    },

    submitBatchUpload() {
      if (!this.canBatchUpload) {
        this.$message.warning("请选择文件");
        return;
      }

      this.batchUploadLoading = true;

      var formData = new FormData();
      for (var i = 0; i < this.selectedTxtFiles.length; i++) {
        formData.append("files", this.selectedTxtFiles[i]);
      }

      this.$axios
        .post(api.batchUploadSpectrogram + "?fileType=txt", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          this.batchUploadLoading = false;
          if (res.data.code === 200) {
            var failCount = res.data.data && res.data.data.failCount ? res.data.data.failCount : 0;
            if (failCount > 0) {
              this.$message.warning(res.data.msg);
              this.downloadErrorExcel(res.data.data.errorDetails);
            } else {
              this.$message.success(res.data.msg);
            }
            this.batchUploadDialogVisible = false;
            this.selectedTxtFiles = [];
            this.getList();
          } else {
            this.$message.error(res.data.msg || "上传失败");
          }
        })
        .catch((err) => {
          this.batchUploadLoading = false;
          this.$message.error("网络异常");
        });
    },

    downloadErrorExcel(errorDetails) {
      if (!errorDetails || errorDetails.length === 0) return;
      this.$axios
        .post(api.exportUploadSpectrogramErrorExcel, errorDetails, {
          responseType: "blob",
        })
        .then((res) => {
          if (res.data) {
            var url = window.URL.createObjectURL(new Blob([res.data]));
            var link = document.createElement("a");
            link.href = url;
            link.download = "上传异常报告.xlsx";
            link.click();
            window.URL.revokeObjectURL(url);
          }
        })
        .catch((err) => {
          this.$message.error("下载异常报告失败");
        });
    },

    productImageUrls,
    brandDisplay,
    typeDisplay,

    formatTime(time) {
      if (!time) return "-";
      if (typeof time === "string") return time.substring(0, 19);
      return time;
    },

    getDictLabel(dictKey, value) {
      if (value == null) return "-";
      var dict = this.dicts[dictKey];
      if (!dict) return "未知";
      var item = null;
      for (var i = 0; i < dict.length; i++) {
        if (dict[i].value === value) {
          item = dict[i];
          break;
        }
      }
      return item ? item.label : "未知";
    },

    getDictColor(dictKey, value) {
      if (value == null) return "#333";
      var dict = this.dicts[dictKey];
      if (!dict) return "#333";
      var item = null;
      for (var i = 0; i < dict.length; i++) {
        if (dict[i].value === value) {
          item = dict[i];
          break;
        }
      }
      return item ? item.color : "#333";
    },

    getOperatorUserId() {
      const tokenStr = sessionStorage.getItem("TOKEN") || "";
      const tokenParts = tokenStr.split("_");
      return tokenParts.length > 1 ? parseInt(tokenParts[1], 10) : 0;
    },

    formatMoney(v) {
      if (v == null || v === "") return "-";
      const n = Number(v);
      if (Number.isNaN(n)) return String(v);
      return n.toFixed(2);
    },

    /** 寄售/鉴别订单：已支付且仍有可退金额时展示退款 */
    canXwOrderRefund(row) {
      if (!row || !row.orderId) return false;
      const orderType = Number(row.orderType);
      if (orderType !== 1 && orderType !== 2) return false;
      return canRefundXwOrder(row, {
        statusKey: "sourceOrderStatus",
        closedKey: "sourceOrderIsClosed",
        orderIdKey: "orderNo",
        priceKey: "sourceOrderPrice",
        paidAmountKey: "sourceOrderPaidAmount",
        refundedAmountKey: "sourceOrderRefundedAmount",
      });
    },

    refundXwOrder(row) {
      if (!this.canXwOrderRefund(row)) return;
      runXwOrderRefund(this, api.xwOrderAdminRefund, row, (r) => {
        const amounts = resolveXwOrderAmounts(r, {
          priceKey: "sourceOrderPrice",
          paidAmountKey: "sourceOrderPaidAmount",
          refundedAmountKey: "sourceOrderRefundedAmount",
        });
        return {
          orderId: r.orderNo,
          orderNo: r.orderNo || r.orderId,
          refundAmount: amounts.remainingAmount > 0 ? amounts.remainingAmount : amounts.servicePrice,
          ...amounts,
          sfjs: Number(r.orderType) === 1 ? "1" : "0",
          consignMode: r.consignMode,
        };
      }).then(() => {
        this.getList();
      }).catch(() => {});
    },

    canCloseXwOrderJob(row) {
      const orderType = Number(row.orderType);
      if (orderType !== 1 && orderType !== 2) return false;
      return canCloseXwOrder(row, {
        statusKey: "sourceOrderStatus",
        closedKey: "sourceOrderIsClosed",
        orderIdKey: "orderNo",
      });
    },

    closeXwOrder(row) {
      if (!this.canCloseXwOrderJob(row)) return;
      runXwOrderClose(
        this,
        api.xwOrderAdminClose,
        row,
        (r) => ({
          orderId: r.orderNo,
          orderNo: r.orderNo || r.orderId,
        })
      ).then(() => {
        this.getList();
      }).catch(() => {});
    },

    /** 安心购：不符退回/无法鉴别补退 */
    canInspectionIssueRefund(row) {
      if (!row || !row.orderId) return false;
      if (Number(row.orderType) !== 4) return false;
      if (Number(row.sourceInspectionResult) !== 3) return false;
      const status = Number(row.sourceOrderStatus);
      return status !== 5 && status !== 6;
    },

    refundInspectionIssue(row) {
      if (!this.canInspectionIssueRefund(row)) return;
      this.$confirm(`确认为订单 ${row.orderNo || row.orderId} 发起不符退回退款？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.issueRefundLoadingId = row.orderId;
        this.$https(api.refundForInspectionIssue, {
          orderId: row.orderId,
          operatorUserId: this.getOperatorUserId(),
          refundReason: "作业列表手动不符退回退款",
        }, "POST").then((res) => {
          if (res.data && res.data.code === 200) {
            this.$message.success("退款成功");
            this.getList();
          } else {
            this.$message.error((res.data && res.data.msg) || "退款失败");
          }
        }).finally(() => {
          this.issueRefundLoadingId = null;
        });
      }).catch(() => {});
    },

    /** 闲置/安心购：汇付未分账退款 */
    canSecondhandReverseRefund(row) {
      if (!row || !row.orderId) return false;
      const orderType = Number(row.orderType);
      if (orderType !== 3 && orderType !== 4) return false;
      if (this.canInspectionIssueRefund(row)) return false;
      const isPay = Number(row.sourceOrderIsPay || 0) === 1;
      const status = Number(row.sourceOrderStatus);
      return isPay && (status === 1 || status === 2);
    },

    openReverseRefundDialog(row) {
      if (!row || !row.orderId) return;
      this.reverseRefundOrder = row;
      this.reverseRefundForm = { refundAmount: "", reason: "" };
      this.reverseRefundSubmitLoading = false;
      this.reverseRefundVisible = true;
    },

    /** 闲置/安心购：汇付已分账退款 */
    canSecondhandDivRefund(row) {
      if (!row || !row.orderId) return false;
      const orderType = Number(row.orderType);
      if (orderType !== 3 && orderType !== 4) return false;
      if (this.canInspectionIssueRefund(row)) return false;
      const isPay = Number(row.sourceOrderIsPay || 0) === 1;
      const status = Number(row.sourceOrderStatus);
      return isPay && (status === 3 || status === 4);
    },

    openDivRefundDialog(row) {
      if (!row || !row.orderId) return;
      this.divRefundOrder = row;
      this.divRefundForm = { refundAmount: "", reason: "" };
      this.divRefundSubmitLoading = false;
      this.divRefundVisible = true;
    },

    submitReverseRefund() {
      if (!this.reverseRefundOrder || !this.reverseRefundOrder.orderId) return;
      const rawAmt = String((this.reverseRefundForm && this.reverseRefundForm.refundAmount) || "").trim();
      let refundAmount = null;
      if (rawAmt) {
        const n = Number(rawAmt);
        if (Number.isNaN(n) || n <= 0) {
          this.$message.warning("退款金额需大于0");
          return;
        }
        refundAmount = Number(n.toFixed(2));
      }
      const payload = {
        orderId: this.reverseRefundOrder.orderId,
        reason: String((this.reverseRefundForm && this.reverseRefundForm.reason) || "").trim(),
      };
      if (refundAmount != null) payload.refundAmount = refundAmount;
      this.reverseRefundSubmitLoading = true;
      this.$https(api.huifuReverseRefundSecondhandOrder, payload, "POST")
        .then((res) => {
          if (res.data && res.data.code === 200) {
            this.$message.success("退款成功");
            this.reverseRefundVisible = false;
            this.getList();
          } else {
            this.$message.error((res.data && res.data.msg) || "退款失败");
          }
        })
        .finally(() => {
          this.reverseRefundSubmitLoading = false;
        });
    },

    submitDivRefund() {
      if (!this.divRefundOrder || !this.divRefundOrder.orderId) return;
      const rawAmt = String((this.divRefundForm && this.divRefundForm.refundAmount) || "").trim();
      let refundAmount = null;
      if (rawAmt) {
        const n = Number(rawAmt);
        if (Number.isNaN(n) || n <= 0) {
          this.$message.warning("退款金额需大于0");
          return;
        }
        refundAmount = Number(n.toFixed(2));
      }
      const payload = {
        orderId: this.divRefundOrder.orderId,
        reason: String((this.divRefundForm && this.divRefundForm.reason) || "").trim(),
      };
      if (refundAmount != null) payload.refundAmount = refundAmount;
      this.divRefundSubmitLoading = true;
      this.$https(api.huifuDivRefundSecondhandOrder, payload, "POST")
        .then((res) => {
          if (res.data && res.data.code === 200) {
            this.$message.success("退款成功");
            this.divRefundVisible = false;
            this.getList();
          } else {
            this.$message.error((res.data && res.data.msg) || "退款失败");
          }
        })
        .finally(() => {
          this.divRefundSubmitLoading = false;
        });
    },
  },
};
</script>

<style scoped>
#mainBox {
  width: 100%;
  min-height: 100%;
  min-width: 0;
  overflow-x: hidden;
  padding-bottom: 48px;
  box-sizing: border-box;
  background: #fff;
}

.historyTag {
  width: 100%;
  box-sizing: border-box;
}

.search-box {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin: 20px 0;
  row-gap: 8px;
  column-gap: 12px;

  .search-item {
    display: flex;
    align-items: center;
  }
}

.operate-btns {
  display: flex;
  flex-flow: row wrap;
  margin-bottom: 20px;
  gap: 10px;
}

.data-table {
  padding: 0 20px;
}

.inspection-no {
  font-weight: 600;
}

.excellent_box {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.excellent_main {
  width: 600px;
  background: #fff;
  border-radius: 4px;
  overflow: hidden;
}

.excellent_top {
  height: 44px;
  background: #409eff;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  font-size: 14px;
}

.excellent_top i {
  position: absolute;
  right: 10px;
  font-size: 18px;
  cursor: pointer;
}

.excellent_content {
  padding: 30px 20px;
}

.excellent_li {
  margin-bottom: 20px;
  align-items: flex-start;
  display: flex;
  flex-direction: column;
}

.txt-upload-container {
  display: flex;
  width: 100%;
  gap: 15px;

  .txt-upload-left {
    flex-shrink: 0;
    flex: 1;
  }

  .txt-upload-right {
    min-width: 0;
    padding-right: 60px;
  }
}

.selected-files {
  margin-top: 20px;
  padding: 8px;
  background: #f5f5f5;
  border-radius: 4px;
  max-height: 200px;
  overflow-y: auto;

  .files-header {
    font-weight: bold;
    margin-bottom: 8px;
    color: #409eff;
  }

  .file-item {
    font-size: 12px;
    color: #666;
    margin-bottom: 4px;
    word-break: break-all;
  }
}



.no-files {
  color: #999;
  font-size: 12px;
  text-align: center;
  padding: 20px 0;
}

.job-img-cell {
  display: flex;
  justify-content: center;
  gap: 4px;
  flex-wrap: wrap;
}

.job-img-thumb {
  width: 44px;
  height: 44px;
  border-radius: 4px;
  cursor: pointer;
}

.job-op-btns {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 6px 4px;
  justify-content: flex-start;
  width: 100%;
  max-width: 132px;
}

.job-op-btns .el-button--mini {
  padding: 5px 7px;
  margin: 0 !important;
  line-height: 1.2;
  white-space: nowrap;
}
</style>

<style>
.inspection-job-detail-dialog .el-dialog__body {
  padding: 12px 20px 20px;
}
.detail-dialog-body {
  max-height: calc(90vh - 130px);
  overflow-y: auto;
}
.inspection-verify-dialog.el-dialog {
  margin-top: 10vh !important;
}
.inspection-verify-dialog .el-dialog__body {
  padding: 12px 20px 16px;
  overflow: hidden;
}

/* 操作栏：允许单元格内按钮换行，行高随行数撑开 */
.data-table td.job-op-col {
  vertical-align: top;
}
.data-table td.job-op-col .cell {
  overflow: visible;
  white-space: normal;
  word-break: normal;
  line-height: normal;
  padding-top: 8px;
  padding-bottom: 8px;
}
.data-table .el-table__fixed-right td.job-op-col .cell,
.data-table .el-table__fixed-right-patch + .el-table__fixed-right td.job-op-col .cell {
  overflow: visible;
  white-space: normal;
}

.inspection-report-preview-dialog .el-dialog__body {
  padding: 0;
  background: #2c2c2c;
}

.report-preview-dialog-body {
  max-height: calc(92vh - 110px);
  overflow-y: auto;
  overflow-x: hidden;
}
</style>



// WEBPACK FOOTER //
// src/pages/inspectionJob/index.vue